import { Schema, Types, model, models, Model, Document } from "mongoose";
import { NetworkSymbols } from "based-auth/networks";
import { stringifyFields } from "based-shared/utils/stringify-fields";

export interface IBoardInvitation extends Document {
  _id: string;
  boardId: string;
  chainId: number;
  boardTitle: string;
  invitedBy: {
    network: NetworkSymbols;
    address: string;
  };
  invitee: {
    type: "wallet" | "profile" | "twitter";
    identifier: string; // wallet address, profile ID, or twitter handle
    network?: NetworkSymbols; // for wallet invites
  };
  status: "pending" | "accepted" | "rejected" | "expired";
  message?: string;
  expiresAt?: Date;
  respondedAt?: Date;
  createdAt: Date;
  updatedAt: Date;
}

const boardInvitationSchema = new Schema<IBoardInvitation>(
  {
    boardId: { type: String, required: true },
    chainId: { type: Number, required: true },
    boardTitle: { type: String, required: true },
    invitedBy: {
      network: {
        type: String,
        required: true,
      },
      address: {
        type: String,
        required: true,
      },
    },
    invitee: {
      type: {
        type: String,
        enum: ["wallet", "profile", "twitter"],
        required: true,
      },
      identifier: {
        type: String,
        required: true,
      },
      network: {
        type: String,
        required: false,
      },
    },
    status: {
      type: String,
      enum: ["pending", "accepted", "rejected", "expired"],
      default: "pending",
    },
    message: {
      type: String,
      required: false,
    },
    expiresAt: {
      type: Date,
      required: false,
    },
    respondedAt: {
      type: Date,
      required: false,
    },
  },
  {
    timestamps: true,
    toObject: {
      getters: true,
      versionKey: false,
      transform: (doc, ret: any) => {
        ret.id = ret._id.toString();
        delete ret._id;
        delete ret.__v;

        return stringifyFields(ret);
      },
    },
  }
);

boardInvitationSchema.index({ boardId: 1, "invitee.identifier": 1 });
boardInvitationSchema.index({ "invitedBy.address": 1, "invitedBy.network": 1 });
boardInvitationSchema.index({ status: 1, expiresAt: 1 });

export const BoardInvitationModel: Model<IBoardInvitation> =
  models?.BoardInvitation || model<IBoardInvitation>("BoardInvitation", boardInvitationSchema);